<template>
	<div
		class="scoreboard"
	>
		<div class="team-col">
			<div class="team">
				<div class="logo">
					<img
						class="participant-image"
						:src="homeTeamImage"
					>
				</div>
				<div class="team-code">
					{{ homeTeamLabel }}
				</div>
			</div>
		</div>
		<div class="score">
			<div class="score-upper">
				<div v-if="showTime">
					{{ currentTime }}
				</div>
			</div>
			<div class="score-content">
				<div class="left-score">
					{{ homeTeamScore }}
				</div>
				<div class="score-divider" />
				<div class="right-score">
					{{ guestTeamScore }}
				</div>
			</div>
		</div>
		<div class="team-col">
			<div class="team">
				<div class="logo">
					<img
						class="participant-image"
						:src="guestTeamImage"
					>
				</div>
				<div class="team-code">
					{{ guestTeamLabel }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { padStart } from 'lodash-es';

export default {
	name:  'UltimateFrisbeeScoreboard',
	props: {
		scoreZones: {
			type: Array,
		},
		event: {
			type: Object,
		},
		currentScoreZone: {
			type: Object,
		},
		gameTime: {
			type: Object,
		},
		showTime: {
			type:    Boolean,
			default: true,
		},
	},
	computed: {
		homeTeam() {
			return this.event.participants.find((item) => item.type === 'home');
		},
		guestTeam() {
			return this.event.participants.find((item) => item.type === 'guest');
		},
		homeTeamScore() {
			return Object.values(this.currentScoreZone.score)
				.find((s) => s.participant.participatable.id === this.homeTeamId).value;
		},
		guestTeamScore() {
			return Object.values(this.currentScoreZone.score)
				.find((s) => s.participant.participatable.id === this.guestTeamId).value;
		},
		homeTeamLabel() {
			return this.homeTeam?.participatable.club.code;
		},
		guestTeamLabel() {
			return this.guestTeam?.participatable.club.code;
		},
		homeTeamImage() {
			return this.homeTeam?.participatable.imageUrl;
		},
		guestTeamImage() {
			return this.guestTeam?.participatable.imageUrl;
		},
		guestTeamId() {
			return this.guestTeam.participatable.id;
		},
		homeTeamId() {
			return this.homeTeam.participatable.id;
		},
		currentTime() {
			const { seconds, minutes } = this.gameTime;

			return `${padStart(minutes, 2, '0')}:${padStart(Math.floor(seconds), 2, '0')}`;
		},
	},
};
</script>

<style lang="scss">
@import '@videotools/sass/fonts';

.scoreboard {
	display: flex;
	text-align: center;
	@include text-lg-2(true);

	.team-col {
		display: flex;
		flex-direction: column;

		.team {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			background: var(--color-grey-200);
			width: 64px;
			height: 100px;
			@include text-md-2;
			font-weight: 600;

			.participant-image {
				width: 48px;
				height: 48px;
			}
		}
	}

	.score {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		background: var(--color-shadow-grey);
		width: 161px;
		height: 100px;

		.score-upper {
			display: flex;
			@include text-md-2;
			font-weight: 600;
			margin-bottom: 4px;
		}

		.score-content {
			display: flex;
			align-items: center;
			font-size: 48px;
			font-weight: 600;
			line-height: 56px;

			.left-score,
			.right-score {
				width: 55px;
			}

			.left-score {
				text-align: right;
			}

			.right-score {
				text-align: left;
			}

			.score-divider {
				flex-shrink: 0;
				height: 35px;
				width: 1px;
				background: var(--color-grey-300);
				margin-left: 12px;
				margin-right: 12px;
			}
		}
	}
}
</style>
